import {DomainEvent} from './DomainEvent';
import {CompetitionSeason} from '../resources/CompetitionSeason';

export class CompetitionSeasonDeactivated extends DomainEvent<CompetitionSeason> {}
